import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import readableFileSize from 'filesize';
import DetailItem from './DetailItem';
import { deviationHasFileSizeMetadata } from './helpers';

export interface Props {
  deviation: PapiDeviation;
}

export const OriginalSize: React.FC<Props> = ({ deviation }) => {
  if (!deviationHasFileSizeMetadata(deviation)) {
    return null;
  }
  const { filesize, width, height } = deviation.extended!.originalFile!;
  return (
    <DetailItem
      name="itemsize"
      transPrefix={deviation.isVideo ? 'video.' : undefined}
      value={`${width}x${height}px ${readableFileSize(filesize)}`}
    />
  );
};
OriginalSize.displayName = 'OriginalSize';

export default OriginalSize;
